import { forwardRef, type Ref, type SVGProps } from "react";
const IconFileSplitOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M7 19c.552.002.998.448 1 1a1.003 1.003 0 0 1-1 1h-.021v7.099l.001.003h.001l.003.002h17.989l.003-.002.003-.003v-7.101A.998.998 0 0 1 24.983 19H28c.552.002.998.448 1 1a1.003 1.003 0 0 1-1 1h-1.021v7.104a2.006 2.006 0 0 1-1.796 1.988l-.204.012h-18l-.205-.012a2.006 2.006 0 0 1-1.795-1.988V21H4a1 1 0 1 1 0-2z"
    />
    <path
      fill="currentColor"
      d="M14 19c.552.002.998.448 1 1a1.003 1.003 0 0 1-1 1h-3a1 1 0 1 1 0-2zm7 0c.552.002.998.448 1 1a1.003 1.003 0 0 1-1 1h-3a1 1 0 1 1 0-2z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.967 2a3.74 3.74 0 0 1 2.41 1.001l5.59 5.59a3.73 3.73 0 0 1 1 2.41v.59c0 .764-.012 2.566-.02 3.409H28c.552.002.998.448 1 1a1.003 1.003 0 0 1-1 1h-3a1 1 0 0 1-.045-1.998l.012-2.917h-7c-.552-.002-.998-.533-1-1.084v-7h-10L6.922 15H7c.552.002.998.448 1 1a1.003 1.003 0 0 1-1 1H4a1 1 0 1 1 0-2h.964l.003-10.999a2.007 2.007 0 0 1 2-2.001zm1 8.001h5.59l-5.59-5.59z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M14 15c.552.002.998.448 1 1a1.003 1.003 0 0 1-1 1h-3a1 1 0 1 1 0-2zm7 0c.552.002.998.448 1 1a1.003 1.003 0 0 1-1 1h-3a1 1 0 1 1 0-2z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconFileSplitOutlineSVG);
ForwardRef.displayName = "IconFileSplitOutline";
export { ForwardRef as IconFileSplitOutline };
